import React from 'react';
import { Badge } from '@/components/ui/badge';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';
import { SubtramiteRow } from './SubtramiteRow';
import { SubtramiteGroup } from './useGroupedSubtramites';

interface GroupedSubtramiteListProps {
  groups: SubtramiteGroup[];
  tramite: any;
  variant?: 'default' | 'compact';
}

export const GroupedSubtramiteList: React.FC<GroupedSubtramiteListProps> = ({
  groups,
  tramite,
  variant = 'default',
}) => {
  // Todos los grupos expandidos por defecto
  const defaultOpenValues = groups.map(group => group.categoryId);

  return (
    <div>
      <h4 className="text-sm font-medium text-gray-700 mb-3">Detalle por Categoría</h4>
      <Accordion type="multiple" defaultValue={defaultOpenValues}>
        {groups.map(group => {
          const IconComponent = group.icon;

          return (
            <AccordionItem key={group.categoryId} value={group.categoryId}>
              <AccordionTrigger>
                <div className="flex items-center justify-between w-full pr-4">
                  <div className="flex items-center gap-2">
                    <IconComponent className="w-5 h-5" />
                    <span className="font-semibold">{group.categoryLabel}</span>
                  </div>
                  <div className="flex items-center gap-2">
                    {group.stats['en-proceso'] > 0 && (
                      <Badge className="bg-orange-100 text-orange-800 text-xs">
                        {group.stats['en-proceso']} En Proceso
                      </Badge>
                    )}
                    {group.stats['finalizado'] > 0 && (
                      <Badge className="bg-green-100 text-green-800 text-xs">
                        {group.stats['finalizado']} Finalizados
                      </Badge>
                    )}
                  </div>
                </div>
              </AccordionTrigger>
              <AccordionContent>
                <div className="grid gap-2 pl-4">
                  {group.subtramites.map(subtramite => (
                    <SubtramiteRow
                      key={subtramite.key}
                      subtramite={subtramite}
                      tramite={tramite}
                    />
                  ))}
                </div>
              </AccordionContent>
            </AccordionItem>
          );
        })}
      </Accordion>
    </div>
  );
};
